// extracted by mini-css-extract-plugin
export var colorSquare = "_tm-0";
export var danger = "_tm-5";
export var lightPink = "_tm-8";
export var neutralBlue = "_tm-7";
export var neutralYellow = "_tm-6";
export var normal = "_tm-1";
export var primary = "_tm-2";
export var primaryLight = "_tm-3";
export var solidBlack = "_tm-g";
export var solidGreen = "_tm-b";
export var solidLightBlue = "_tm-d";
export var solidNavy = "_tm-c";
export var solidOrange = "_tm-f";
export var solidPink = "_tm-e";
export var solidRed = "_tm-9";
export var solidYellow = "_tm-a";
export var success = "_tm-4";